import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { PolicyBox } from './PolicyNotice.styled';

const PolicyNotice = ({ lightTheme, isPolicyShown, setPolicyShown }) => {
  useEffect(() => {
    if (window) setPolicyShown(localStorage.getItem('show_policy') !== 'n');
  }, []);

  function closePolicyHandler() {
    setPolicyShown(false);
    if (window) localStorage.setItem('show_policy', 'n');
  }

  return isPolicyShown ? (
    <PolicyBox className="d-none d-md-block" lightTheme={lightTheme}>
      <div className="container">
        <p>
          We use cookies to ensure the best user experience on our site.&nbsp;
          <Link to="/privacy-policy/" onClick={closePolicyHandler}>
            View our policy.
          </Link>
        </p>
      </div>
      <button type="button" className="close" onClick={closePolicyHandler}>
        <i className="fal fa-times" />
      </button>
    </PolicyBox>
  ) : (
    <></>
  );
};

PolicyNotice.propTypes = {
  lightTheme: PropTypes.bool,
  isPolicyShown: PropTypes.bool.isRequired,
  setPolicyShown: PropTypes.func.isRequired,
};

export default PolicyNotice;
